import {useSelector} from "react-redux";
import {selectCallChangesLive} from "../../store/features/calls/callChangesSlice";
import {callsPollingInterval} from "./callChangesPolling";

export const useCallsPollingInterval = (legacyIntervalMs: number): number =>
    callsPollingInterval(useSelector(selectCallChangesLive), legacyIntervalMs);
